import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'landing-list', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },

  {
    path: 'landing-list/:moduleId',
    loadComponent: () =>
      import(
        './shared/dynamic-components/dynamic-landing-list/dynamic-landing-list.component'
      ).then((m) => m.DynamicLandingListComponent),
  },

  {
    path: ':moduleId/form/:action',
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import(
            './shared/dynamic-components/form-handling/form-handling.component'
          ).then((m) => m.FormHandlingComponent),
      },
      {
        path: '',
        loadComponent: () =>
          import(
            './shared/dynamic-components/form-handling/form-handling.component'
          ).then((m) => m.FormHandlingComponent),
      }
    ]
  },




  {
    path: 'case-details',
    loadComponent: () =>
      import(
        './components/home/case-details/case-details.component'
      ).then((m) => m.CaseDetailsComponent),
  },
  {
    path: 'casedetails',
    loadComponent: () =>
      import('./components/home/case-details/case-details.component').then(
        (m) => m.CaseDetailsComponent
      ),
  },
  {
    path: 'sla',
    loadChildren: () => import('./features/sla/sla.routes').then(m => m.SLA_ROUTES)
  },
  {
    path: 'cases',
    loadChildren: () => import('./features/case-management/case-management.routes').then(m => m.CASE_ROUTES)
  },
  {
    path: 'assignment',
    loadChildren: () => import('./features/assignment/assignment.routes').then(m => m.ASSIGNMENT_ROUTES)
  },
  {
    path: 'availability',
    loadChildren: () => import('./features/availability/availability.routes').then(m => m.AVAILABILITY_ROUTES)
  },
  {
    path: 'workflow-builder',
    loadChildren: () => import('./features/workflow-builder/workflow-builder.routes').then(m => m.WORKFLOW_BUILDER_ROUTES)
  },
  {
    path: 'reports/:menu_id',
    loadComponent: () =>
      import('./components/home/reports/reports.component').then(
        (m) => m.ReportsComponent
      ),
  },
];
